module.exports = __webpack_public_path__ + "static/media/dogzwag.5d37e796.png";